module.exports = __webpack_public_path__ + "static/img/12.1dc15b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/12.png
// module id = uzAt
// module chunks = 0